'use client';

import { useEffect, useRef } from 'react';

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    IconName,
    List,
    ListItem,
    ModalBody,
    Text,
    TextLevels,
    TypographyBold,
} from '@bytel/trilogy-react';

const parentalControlItems = [
    {
        id: 'basic',
        label: 'Basique',
        dataId: 'modal-content-basic',
        description: 'Le premier niveau de protection',
        benefits: [
            'Disponible sur cette ligne mobile uniquement',
            'Filtrage des sites sensibles et des achats uniquement sur le réseau mobile (pas en WiFi)',
        ],
    },
    {
        id: 'child',
        label: 'Mode Enfant',
        dataId: 'modal-content-child',
        description: "Le contrôle parental avec géolocalisation et suivi du temps d'écran",
        benefits: [
            'Jusqu’à 5 enfants protégés',
            'Disponible quels que soient la ligne mobile et l’appareil',
            'Filtrage des sites sensibles sur le réseau mobile et le WiFi',
            'Consultation du temps d’écran par appli et réseaux sociaux',
            'Géolocalisation en temps réel *',
        ],
    },
    {
        id: 'advanced-child',
        label: 'Mode Enfant Avancé',
        dataId: 'modal-content-advanced-child',
        description: "Le contrôle parental ultra complet qui vous permet enfin d'agir",
        benefits: [
            'Jusqu’à 5 enfants protégés',
            'Disponible quels que soient la ligne mobile et l’appareil',
            'Filtrage des sites sensibles sur le réseau mobile et le WiFi',
            'Consultation du temps d’écran par appli et réseaux sociaux',
            'Blocage des réseaux sociaux',
            "Limites du temps d'écran",
            'Routines de déconnexion',
            'Géolocalisation en temps réel *',
            'Pause internet immédiate',
            'Gestion des applis et des jeux',
            'Suivi de ses déplacements',
        ],
    },
] as const;

export default function ParentalControlModal() {
    const accordionRef = useRef<HTMLDivElement>(null);

    //TODO: add feature to trilogy to handle it natively and remove this code?
    useEffect(() => {
        const accordion = accordionRef.current;
        if (!accordion) return;

        const handleToggle = (event: Event) => {
            const openedDetails = event.target as HTMLDetailsElement;
            if (!openedDetails.open) return;

            const allDetails = accordion.querySelectorAll<HTMLDetailsElement>('details');
            allDetails.forEach((details) => {
                if (details !== openedDetails) {
                    details.open = false;
                }
            });
        };

        const allDetails = accordion.querySelectorAll<HTMLDetailsElement>('details');
        allDetails.forEach((details) => {
            details.addEventListener('toggle', handleToggle);
        });

        return () => {
            allDetails.forEach((details) => {
                details.removeEventListener('toggle', handleToggle);
            });
        };
    }, []);

    return (
        <ModalBody>
            <div ref={accordionRef}>
                <Accordion id='accordion-modal-parental'>
                    {parentalControlItems.map(({ id, label, dataId, description, benefits }) => (
                        <AccordionItem open={id === 'basic'} key={id} id={id}>
                            <AccordionHeader>
                                <Text>{label}</Text>
                            </AccordionHeader>
                            <AccordionBody data-id={dataId}>
                                <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.TWO}>
                                    {description}
                                </Text>
                                <List>
                                    {benefits.map((benefit) => (
                                        <ListItem key={benefit} iconName={IconName.CHECK}>
                                            <Text marginless level={TextLevels.TWO}>
                                                {benefit}
                                            </Text>
                                        </ListItem>
                                    ))}
                                </List>
                            </AccordionBody>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </ModalBody>
    );
}
